import React from 'react';
import Flagship from '../../core/flagship';
import Field from '../records/Field';
import {connect} from 'react-redux';
import { Table, Loader, Header, Modal, Button, Select, Icon } from 'semantic-ui-react';
import {shouldShowField, empty} from '../../utils/helpers';

class IoProductForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.editName = this.editName.bind(this);
        this.onSelectService = this.onSelectService.bind(this);
        this.saveAndExit = this.saveAndExit.bind(this);
        this.addError = this.addError.bind(this);
        this.clearError = this.clearError.bind(this);
        this.onCopyFromRFP = this.onCopyFromRFP.bind(this);
        this.onUpdateFlights = this.onUpdateFlights.bind(this);
        this.getSubServiceFields = this.getSubServiceFields.bind(this);
    }

    getInitialState() {
        return {
            ioProductForm: [],
            ioProductData: {},
            ioProductPricingFields: [],
            ioProductServices: [],
            editingName: false,
            errors: [],
            newIoProductService: null,
            newIoProductName: null,
            newIoProductServiceNiceName: null,
            newIoProductLaunch: null,
            lineItemId: null,
            hasCopiedFromRFP: false,
            flights: []
        };
    }

    componentDidMount() {

        let self = this;

        // Get line items attached to RFP for this IO. Only need to pull services to populate available options in dropdown.
        Flagship.get(
            '/io-product/services-available/' + this.props.recordId,
            {},
            function (response) {

                if (response.data.success === true) {
                    let services = [];

                    if ( !empty(response.data.results) ) {
                        
                        response.data.results.map(function(item) {

                            services.push({
                                key: item.id,
                                value: item.line_item_type,
                                text: item.line_item_name
                            });
                        });
                        self.setState({
                            ioProductServices: services
                        });
                    }

                } else {

                    Flagship.error(
                        "Error getting available IO product services from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting available IO product services from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );

    }

    onCopyFromRFP() {
        let self = this;
        Flagship.get(
            'line-item/read/' + this.state.lineItemId,
            {
                withData: true
            },
            function (response) {

                if (response.data.success === true) {
                    let productData = {};

                    response.data.data.map(function(item) {
                        productData[item.field_id] = item.field_value;
                    });


                    self.setState({
                        loading:false,
                        hasCopiedFromRFP: true,
                        ioProductData: productData
                    }, function() {
                        Flagship.notify("Copied info from RFP.");
                    });


                } else {

                    Flagship.error(
                        "Error getting RFP line item data from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting RFP line item data from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }

    onChange(e, data, fieldId, misc) {

        // All other fields
        let ioProductData = Object.assign({},this.state.ioProductData);
        ioProductData[fieldId] = data;

        this.setState({
            ioProductData: ioProductData
        });

        if(misc === "flight") {
            this.onUpdateFlights(data);
        }

        if (typeof this.props.onChange === "function") {
            this.props.onChange(ioProductData);
        }

    }


    editName() {
        this.setState({
            editingName: true
        });
    }

    onSelectService(e, data) {

        let service = data.value;

        let option = this.state.ioProductServices.find(function(element) {
            return element.value === service;
        });

        service = option.text;

        this.setState({
            lineItemId: option.key
        });


        this.setState({
            newIoProductService: data.value,
            newIoProductServiceNiceName: service,
            newIoProductName: service
        }, function() {

            let self = this;

            let mainService = false;

            // Determine main service (depending on if this is a sub-option)
            Flagship.config.lineItemServices.map(function(item) {
                if ( item.value === self.state.newIoProductService ) {
                    mainService = item.value;
                } else if (item.hasOwnProperty("subOptions")) {
                    item.subOptions.map(function(subItem) {
                       if (subItem.value === self.state.newIoProductService) {
                           mainService = item.value;
                       }
                    });
                }
            });

            Flagship.get(
                'io-product-form/' + mainService,
                {
                    withData: false
                },
                function (response) {

                    if (response.data.success === true) {

                        self.setState({
                            ioProductForm: response.data.results
                        }, function() {
                            // Also get child service fields
                            if ( mainService !== self.state.newIoProductService ) {
                                self.getSubServiceFields();
                            }
                        });

                    } else {

                        Flagship.error(
                            "Error getting IO product form from Flagship API server.",
                            self.props.recordId,
                            self.props.userId
                        );
                    }
                },
                function (err) {

                    Flagship.error(
                        "Error getting IO product form from Flagship API server: " + err,
                        self.props.recordId,
                        self.props.userId
                    );
                }
            );
        });
    }
    
    getSubServiceFields() {
        let self = this;

        // Add sub service fields
        Flagship.get(
            'io-product-form/' + this.state.newIoProductService,
            {},
            function (response) {

                if (response.data.success === true) {

                    let combinedForm = [...self.state.ioProductForm, ...response.data.results];

                    combinedForm.sort(function(a,b) {return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0);} );

                    self.setState({
                        ioProductForm: combinedForm
                    });

                } else {

                    Flagship.error(
                        "Error getting IO product form from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting IO product form from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }

    addError(fieldId) {

        let errors = this.state.errors;

        if (errors.indexOf(fieldId) !== -1) {
            errors.push(fieldId);
        }

        this.setState({
            errors: errors
        });
    }

    clearError(fieldId) {

        let errors = this.state.errors;
        for(var i = errors.length - 1; i >= 0; i--) {
            if(errors[i] === fieldId) {
                errors.splice(i, 1);
            }
        }

        this.setState({
            errors: errors
        });
    }

    onUpdateFlights(flights) {

        this.setState({
            flights: flights
        });

    }

    saveAndExit() {

        let self = this;
        Flagship.post(
            "io-product/create/" + self.props.recordId,
            {
                io_product_name: self.state.newIoProductName,
                io_product_type: self.state.newIoProductService,
                flights: self.state.flights,
                data: self.state.ioProductData
            },
            function(response) {
                if (response.data.success === true) {
                    Flagship.event("create-io-product", self.state.newIoProductServiceNiceName, self.props.recordId, self.props.userId);
                    Flagship.notify("IO product added.","success");
                    self.setState(self.getInitialState(), function() {

                        if (typeof self.props.onAddIoProduct === "function") {
                            self.props.onAddIoProduct();
                        }
                    });
                } else {
                    Flagship.error("Error adding IO product.", self.props.recordId, self.props.userId);
                }
            }, function(err) {
                Flagship.error("Error adding IO product: " + err, self.props.recordId, self.props.userId);
            }
        );
    }

    render() {

        if(empty(this.state.ioProductForm)) {
            return (
                <Table>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan="5">
                                <Loader className="flagship-loader" active inline='centered' />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            );
        } else {

            let self = this;
            return (
                <Modal
                    open={true}
                    onClose={this.props.cancelAddNew}
                    closeIcon
                >
                    <Header>
                        <Icon name="pin" style={{display:"inline"}} /> Add New IO Product
                        { this.state.newIoProductService !== null ?
                        <Button
                            color="grey"
                            inverted={true}
                            content="Copy RFP Data"
                            floated="right"
                            icon="copy"
                            className="io-copy-from-rfp"
                            onClick={this.onCopyFromRFP}
                        /> : null }
                    </Header>
                    <Modal.Content>

                        {this.state.newIoProductService === null ?
                            <div>
                                <p>Add an IO product for each item that should be executed.<br/>Run dates that are flighted should have a separate IO product for each flight.</p>
                                <Select
                                    placeholder="Select a Service from the Proposal..."
                                    options={self.state.ioProductServices}
                                    onChange={(e, data) => {self.onSelectService(e, data)}}
                                />
                            </div>
                            :
                            <div>
                                {this.state.editingName === true ?
                                    <Header as="h3" color="grey">
                                        <div className="ui input">
                                            <input
                                                autoFocus
                                                placeholder={self.state.newIoProductName}
                                                onChange={(e, data) => self.onChange(e, data, "name")}
                                                style={
                                                    {
                                                        minWidth: '400px',
                                                        maxWidth: '100%'
                                                    }
                                                }
                                            />
                                        </div>
                                        <span className="margin-left">{' (' + this.state.newIoProductServiceNiceName + ')'}</span>
                                    </Header>
                                    :
                                    <Header as="h3" onClick={self.editName} className="hover-dotted-outline">
                                        {self.state.newIoProductName +
                                        (self.state.newIoProductName !== this.state.newIoProductServiceNiceName ?
                                                '(' + this.state.newIoProductServiceNiceName + ')' :
                                                ''
                                        )
                                        }
                                    </Header>
                                }

                                {this.state.ioProductForm.map(function(item, i) {

                                    let fieldId = item.field_id;

                                    let value = (!empty(self.state.ioProductData[fieldId]) ? self.state.ioProductData[fieldId] : null);
                                    item.default = value;

                                    return( shouldShowField( item, self.state.ioProductData) ?
                                            <Field
                                                contentType="ioProduct"
                                                addError={self.addError}
                                                clearError={self.clearError}
                                                model={"IoProduct." + i}
                                                key={'field-' + i}
                                                value={value}
                                                default={value}
                                                filterInput={item.validation !== '' ? item.validation : null}
                                                onChange={(e, data, fieldId, misc) => self.onChange(e, data, fieldId, misc)}
                                                {...item} />
                                            : null
                                    );
                                })}
                            </div>}
                    </Modal.Content>
                    <Modal.Actions>
                        {this.state.hasCopiedFromRFP === true ?
                            <span className="verify-warning"><Icon name="warning" color="red" circular={true} inverted={true}/>
                                &nbsp;Please verify all info from the RFP (and update if needed).
                            </span>
                            : null }
                        <Button disabled={this.state.newIoProductService === null} primary onClick={this.saveAndExit}>
                            <Icon name='plus' /> Add IO Product
                        </Button>
                        <Button color='grey' onClick={this.props.cancelAddNew}>
                            <Icon name='dont' /> Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>

            );

        }
    }
}

function mapStateToProps(state) {
    return {
        username: state.main.username,
        userId: state.main.userId,
        userRole: state.main.userRole
    };
}

export default connect(
    mapStateToProps,
    null
)(IoProductForm);


// WEBPACK FOOTER //
// ./src/components/modals/IoProductAddModal.js